var map = {
	"./en/img/flag.svg": 57444,
	"./fr/img/flag.svg": 24519,
	"./fr/img/starbucks-rewards-dark.svg": 80849,
	"./fr/img/starbucks-rewards-light.svg": 55927,
	"./fr/img/summer-game-logo-dark.svg": 14456,
	"./fr/img/summer-game-logo-light.svg": 26264,
	"./share/img/flag.svg": 26060,
	"./share/img/prizes/booster.webp": 58937,
	"./share/img/prizes/coupon-bogo.webp": 1869,
	"./share/img/prizes/coupon-half-off.webp": 95125,
	"./share/img/prizes/doordash.webp": 88027,
	"./share/img/prizes/gift-card.webp": 24782,
	"./share/img/prizes/goodr.webp": 74900,
	"./share/img/prizes/list/goodr.webp": 94545,
	"./share/img/prizes/origin.webp": 75309,
	"./share/img/prizes/patches.webp": 35819,
	"./share/img/prizes/stars-100.webp": 8878,
	"./share/img/prizes/stars-200.webp": 26823,
	"./share/img/prizes/stars-25.webp": 69826,
	"./share/img/prizes/stars-300.webp": 87996,
	"./share/img/prizes/stars-400.webp": 11717,
	"./share/img/prizes/stars-5.webp": 4418,
	"./share/img/prizes/stars.webp": 86112,
	"./share/img/prizes/stickers.webp": 40211,
	"./share/img/prizes/striped-tumbler.webp": 53588,
	"./share/img/prizes/sweeps.webp": 62418,
	"./share/img/prizes/ticket.webp": 63199,
	"./share/img/prizes/tote.webp": 70649,
	"./share/img/prizes/trip.webp": 91368,
	"./share/img/prizes/tumbler.webp": 94458,
	"./share/img/prizes/water-bottle.webp": 54505,
	"./share/img/starbucks-rewards-dark.svg": 86786,
	"./share/img/starbucks-rewards-light.svg": 29818,
	"./share/img/summer-game-logo-dark.svg": 79937,
	"./share/img/summer-game-logo-light.svg": 62823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21168;